export function notify(type, message, timer) {
	const str = typeof message === `object` ? message.toString() : message;

	import(`sweetalert2/src/sweetalert2.js`).then(({ default: Swal }) => {
		Swal.fire({
			toast: true,
			position: `top-end`,
			showConfirmButton: false,
			timer: typeof timer === `number` ? timer : 3000,
			timerProgressBar: true,
			icon: type,
			html: str,
			didOpen: (toast) => {
				toast.addEventListener(`mouseenter`, Swal.stopTimer);
				toast.addEventListener(`mouseleave`, Swal.resumeTimer);
				toast.addEventListener(`click`, () => Swal.close());
			},
		});
	});
}
